import type { CmsSidebarSectionFragment } from "@workspace/casino_core/queries/CmsSidebarQuery";
import type { FC } from "react";
import DynamicHugeIcon from "../../../../../utils/DynamicHugeIcon";

type Props = Pick<CmsSidebarSectionFragment, "icon" | "hugeIcon"> & {
  size?: number;
  className?: string;
};

const SidebarIcon: FC<Props> = ({ size = 20, className, ...item }) => {
  if (item.hugeIcon) {
    return (
      <DynamicHugeIcon
        iconName={item.hugeIcon.iconName}
        color={item.hugeIcon.color ?? undefined}
        iconStyle={item.hugeIcon.iconStyle ?? "stroke"}
        size={size}
        className={className}
      />
    );
  }

  if (item.icon?.url) {
    return (
      <img
        src={item.icon.url}
        width={size}
        height={size}
        className={className}
        // Eager icons inside a Suspense boundary are preloaded ahead of the LCP image.
        loading="lazy"
      />
    );
  }

  return null;
};

export default SidebarIcon;
